export default __webpack_public_path__ + "static/media/skewl-logo.ac64386e.svg";